// extracted by mini-css-extract-plugin
export default {"root":"storage-selected-bags_root__TbWIJ"};